import { render } from "./FilterWinners.vue?vue&type=template&id=0894b410&scoped=true"
import script from "./FilterWinners.vue?vue&type=script&lang=js"
export * from "./FilterWinners.vue?vue&type=script&lang=js"

import "./FilterWinners.vue?vue&type=style&index=0&id=0894b410&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0894b410"

export default script